
export default function FutureVisionSection() {
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="mx-auto px-6 lg:px-[15%]">
        {/* 主要内容区域 */}
        <div className="max-w-6xl mx-auto">
          {/* 未来展望 */}
          <div className="text-center mb-16">
            <div 
              className="relative rounded-3xl p-12 lg:p-16 text-white overflow-hidden bg-cover bg-center"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/267a14978d60f90c3b0b393ae1236230.jpg')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-[#663333]/90 to-[#cc9966]/90"></div>
              
              <div className="relative z-10">
                <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold mb-6">
                  未来展望
                </h2>
                <p className="text-sm sm:text-lg lg:text-xl leading-relaxed max-w-4xl mx-auto mb-8">
                  我们将继续秉承"三真"承诺，不断完善年份茶标准体系，
                  致力于成为全球最具影响力的年份茶品牌，
                  让世界品味中华茶文化的深厚底蕴。
                </p>
                <div className="w-24 h-1 bg-white/30 mx-auto"></div>
              </div>
            </div>
          </div>

          {/* 发展目标 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            <div className="text-center p-8 bg-[#f8f8f8] rounded-2xl hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6">
                <i className="ri-global-line text-2xl text-white"></i>
              </div>
              <h3 className="text-sm sm:text-lg lg:text-xl font-bold text-[#663333] mb-4">
                全球化布局
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                在全球范围内建设标准化年份茶生产基地，
                将中华茶文化推向世界舞台
              </p>
            </div>

            <div className="text-center p-8 bg-[#f8f8f8] rounded-2xl hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6">
                <i className="ri-microscope-line text-2xl text-white"></i>
              </div>
              <h3 className="text-sm sm:text-lg lg:text-xl font-bold text-[#663333] mb-4">
                科技创新
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                运用现代科技手段，建立更加精准的年份茶
                检测体系和品质评估标准
              </p>
            </div>

            <div className="text-center p-8 bg-[#f8f8f8] rounded-2xl hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-6">
                <i className="ri-leaf-line text-2xl text-white"></i>
              </div>
              <h3 className="text-sm sm:text-lg lg:text-xl font-bold text-[#663333] mb-4">
                可持续发展
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                坚持绿色环保理念，推动茶叶产业的
                可持续发展和生态文明建设
              </p>
            </div>
          </div>

          {/* 发展里程碑 */}
          <div className="bg-gradient-to-r from-[#663333] to-[#774444] rounded-2xl p-8 lg:p-12 text-white">
            <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-center mb-12">
              未来五年发展里程碑
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center space-y-4">
                <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">2025</div>
                <div className="text-sm sm:text-lg font-semibold mb-2">标准制定</div>
                <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                  完成年份茶行业标准制定，成为行业标杆
                </p>
              </div>
              
              <div className="text-center space-y-4">
                <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">2026</div>
                <div className="text-sm sm:text-lg font-semibold mb-2">海外拓展</div>
                <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                  在东南亚、欧美建立销售网络和品牌影响力
                </p>
              </div>
              
              <div className="text-center space-y-4">
                <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">2027</div>
                <div className="text-sm sm:text-lg font-semibold mb-2">技术升级</div>
                <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                  建成智能化生产线和数字化追溯体系
                </p>
              </div>
              
              <div className="text-center space-y-4">
                <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">2028</div>
                <div className="text-sm sm:text-lg font-semibold mb-2">文化传承</div>
                <p className="text-xs sm:text-sm text-gray-200 leading-relaxed">
                  建设茶文化博物馆，传承中华茶文化精髓
                </p>
              </div>
            </div>
          </div>

          {/* 承诺与保证 */}
          <div className="mt-16 text-center">
            <h3 className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold text-[#663333] mb-8">
              我们的承诺
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="p-6 bg-white rounded-xl shadow-lg border-2 border-[#cc9966]/20 hover:border-[#cc9966]/40 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                  <i className="ri-map-pin-fill text-lg text-white"></i>
                </div>
                <h4 className="text-sm sm:text-lg font-bold text-[#663333] mb-3">真产地保证</h4>
                <p className="text-xs sm:text-sm text-gray-600">
                  坚持云南核心产区原料，确保每一片茶叶的正宗出身
                </p>
              </div>
              
              <div className="p-6 bg-white rounded-xl shadow-lg border-2 border-[#cc9966]/20 hover:border-[#cc9966]/40 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                  <i className="ri-time-fill text-lg text-white"></i>
                </div>
                <h4 className="text-sm sm:text-lg font-bold text-[#663333] mb-3">真年份追溯</h4>
                <p className="text-xs sm:text-sm text-gray-600">
                  建立完整的证据链追溯体系，让每一饼茶都有身份证
                </p>
              </div>
              
              <div className="p-6 bg-white rounded-xl shadow-lg border-2 border-[#cc9966]/20 hover:border-[#cc9966]/40 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto mb-4">
                  <i className="ri-flask-fill text-lg text-white"></i>
                </div>
                <h4 className="text-sm sm:text-lg font-bold text-[#663333] mb-3">真转化科学</h4>
                <p className="text-xs sm:text-sm text-gray-600">
                  运用科学仓储管理，确保茶叶在时间中的完美转化
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
